import {eventBus} from "@/plugins/global-funcs";

const state = {
    confirmModal: {
        popup: false
    },
    isLoading: false
}

const getters = {

}

const actions = {

}

const mutations = {
    setModal (state, data) {
        eventBus.$emit('updateModalIndex')
        state.confirmModal = {
            popup: true,
            title: data.title,
            text: data.text,
            buttonText: data.buttonText ? data.buttonText : (data.theme === 'error' ? 'Try again':'ยืนยัน'),
            cancelText: data.cancelText ? data.cancelText : 'ยกเลิก',
            showCancel: data.showCancel !== false, // show as default
            action: data.action ? data.action : () => {},
            theme: data.theme // success, error
        }
    },
    clearModal (state) {
        state.confirmModal = {
            popup: false,
            theme: state.confirmModal.theme // for show til dialog was close completely
        }
    },
    setLoading (state, val = true) {
        state.isLoading = val
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
